import React, { FC } from 'react';
import { Avatar, AvatarProps } from '@bechtel/gds';
import { Text } from '@bechtel/gds';
import { NightShiftAvatarStyled, AvatarTypeIndicatorStyled } from './styled';
import { Trans } from '@lingui/macro';

export const NightShiftAvatar: FC<AvatarProps> = (props) => {
  return (
    <NightShiftAvatarStyled data-testid="night-shift-avatar">
      <Avatar {...props} data-testid="avatar"></Avatar>
      <AvatarTypeIndicatorStyled data-testid="avatar-type-indicator">
        <Text color="white" size="100">
          <Trans>NS</Trans>
        </Text>
      </AvatarTypeIndicatorStyled>
    </NightShiftAvatarStyled>
  );
};
